import API from '../configs/axiosInstance';

const getStixCoreObjectsNumber = ({ body, signal }) => {
  return API({
    url: '/cti-service/graphql',
    method: 'POST',
    data: body,
    signal,
  });
};

const getParametersByType = ({ letter, signal }) => {
  return API({
    url: `/account-service/v1/parameters/${letter}/by-type`,
    method: 'GET',
    signal,
  });
};

const getLatestReportsDrawerBody = ({ signal }) => {
  return API({
    url: `/account-service/v1/parameters/LATEST_REPORTS_DRAWER_BODY/by-type`,
    method: 'GET',
    signal,
  });
};

const threatIntelligenceService = {
  getStixCoreObjectsNumber,
  getParametersByType,
  getLatestReportsDrawerBody,
};

export default threatIntelligenceService;

